import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { catchError } from 'rxjs';
import { AdministrationService } from 'src/app/components/administration/administration.service';
import { CommonService } from '../../services/common.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GetAllExchangeRateResponseModel } from 'src/app/components/administration/administration.model';
import { SendDataService } from '../../services/send-data.service';

@Component({
  selector: 'app-exchange-rate',
  templateUrl: './exchange-rate.component.html',
  styleUrls: ['./exchange-rate.component.scss']
})
export class ExchangeRateComponent extends CommonService implements OnInit{
  @ViewChild('administrationFormData') administrationFormData! : NgForm ;
  getAllExchangeRateData          : any[]=[];

  copyGetAllExchangeRateData          : any[]=[]
  editExchangeRateData                = new GetAllExchangeRateResponseModel();
  isAdd                       : boolean = false;

constructor(
  public renderer:Renderer2,
  public administrationService : AdministrationService,
  public toaster: ToastrService,
  public sendDataService : SendDataService,
) 
{
  super(renderer)
}

ngOnInit(): void {
  this.getAllExchangeRateList();
}


add(){
  if(!this.sendDataService?.permissionVM?.mastersCanAdd) return;
  this.isAdd = true;
  const obj = {id:0, name:'',active:true,currencyId:null,rate:null,description:''}
  this.getAllExchangeRateData?.push(obj);
  this.copyGetAllExchangeRateData?.push(obj);
  setTimeout(()=>{
    const element = document.getElementById(`currencyId${obj.id}`);
    element?.focus();
  },0)
}


cancel(){
  if(this.isAdd)
  {
    this.isAdd = false;
    this.getAllExchangeRateData = this.getAllExchangeRateData.filter((x)=>x.id != 0);
    this.copyGetAllExchangeRateData = this.copyGetAllExchangeRateData.filter((x)=>x.id != 0);
  }
  else if(this.editExchangeRateData?.id && this.editExchangeRateData?.isEdit){
    const index = this.copyGetAllExchangeRateData.findIndex((x)=>x.id == this.editExchangeRateData?.id);
    const singleData =JSON.parse(JSON.stringify(this.copyGetAllExchangeRateData))[index];
    this.getAllExchangeRateData[index] = singleData;
    this.editExchangeRateData = new GetAllExchangeRateResponseModel();
  }  
}


edit(item,formData){
  if(!this.sendDataService?.permissionVM?.mastersCanUpdate) return;
  item.isEdit = true;
  const controlObj = formData?.form?.controls;
  if(controlObj){
    const id = Object.keys(controlObj)[0];
    const element = document.getElementById(id);
    element?.focus();
  }
  this.editExchangeRateData = {...item};
}

checkIsEdit(arr:any[]):boolean{
  return arr?.some((x)=>x.isEdit)
}


  // *********** ExchangeRate API START *********
  // **********get all ExchangeRate *********
  getAllExchangeRateList() {
    this.administrationService.getAllExchangeRate().subscribe({
      next:(res)=>{
        if(res.isSuccess){
          this.getAllExchangeRateData = res.response??[];
          this.editExchangeRateData = new GetAllExchangeRateResponseModel();
          this.copyGetAllExchangeRateData = JSON.parse(JSON.stringify(this.getAllExchangeRateData))??[];
        }else{           
          this.getAllExchangeRateData = [];
          this.copyGetAllExchangeRateData = [];
        }  
      },
      error:(err)=>{
        this.getAllExchangeRateData = [];
        this.copyGetAllExchangeRateData = [];
      } 
    })
  }
  
 // *************insert ExchangeRate **************
  InserExchangeRateList(item) {
    const {id , ...rest} = item;
    this.administrationService.insertExchangeRate(rest)
        .pipe(catchError((err) => this.handleError(err)))
        .subscribe((res) => {
          if(res.isSuccess){
            this.isAdd = false;
            this.getAllExchangeRateList();
            this.toaster.success(res.message);
          }else{
            this.toaster.error(res.errors[0]);
          }  
      });
    }

  // **********update ExchangeRate *********
    UpdateExchangeRateList(item) {
    const {isEdit , ...rest} = item;
    this.administrationService.updateExchangeRate(rest)
        .pipe(catchError((err) => this.handleError(err)))
        .subscribe((res) => {
          if(res.isSuccess){
            
            this.isAdd = false;
            this.getAllExchangeRateList();
            this.toaster.success(res.message);
          }else{
            this.toaster.error(res.errors[0]);
          }  
      });
    }  

    // **********delete ExchangeRate *********
    DeleteExchangeRateList(id) {
      if(!this.sendDataService?.permissionVM?.mastersCanDelete) return;
      this.administrationService.deleteExchangeRate(id)
          .pipe(catchError((err) => this.handleError(err)))
          .subscribe((res) => {
            if(res.isSuccess){
              this.getAllExchangeRateList();
              this.toaster.success(res.message);
            }else{
              this.toaster.error(res.errors[0]);
            }  
      });
    }
  
  // *********** ExchangeRate API END *********
}

